module.exports = __webpack_public_path__ + "img/14.8d4ebc66.png";